module.exports = (__webpack_require__(2))("./core/passiveEvent.js");


//////////////////
// WEBPACK FOOTER
// delegated ./core/passiveEvent.js from dll-reference base
// module id = 99
// module chunks = 22